// frontend/src/pages/Admin/NewsManagement.jsx
import React, { useState, useEffect } from 'react';
import './AdminStyles.css';
import { newsService } from '../../services/newsService';
import ImageUpload from './components/ImageUpload';

const NewsManagement = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingNews, setEditingNews] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    fullDescription: '',
    image: null,
    published: true
  });
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    try {
      const data = await newsService.getAdminNews();
      setNews(data.news);
    } catch (error) {
      console.error('Ошибка загрузки новостей:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleImageSelect = (file) => {
    setFormData(prev => ({ ...prev, image: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formDataToSend = new FormData();
    formDataToSend.append('title', formData.title);
    formDataToSend.append('description', formData.description);
    formDataToSend.append('fullDescription', formData.fullDescription);
    formDataToSend.append('published', formData.published);
    
    if (formData.image instanceof File) {
      formDataToSend.append('image', formData.image);
    }

    try {
      if (editingNews) {
        await newsService.updateNews(editingNews.id, formDataToSend);
      } else {
        await newsService.createNews(formDataToSend);
      }
      
      await loadNews();
      resetForm();
    } catch (error) {
      console.error('Ошибка сохранения новости:', error);
    }
  };

  const handleEdit = (newsItem) => {
    setEditingNews(newsItem);
    setFormData({
      title: newsItem.title,
      description: newsItem.description,
      fullDescription: newsItem.fullDescription || '',
      image: null,
      published: newsItem.published
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить эту новость?')) {
      try {
        await newsService.deleteNews(id);
        await loadNews();
      } catch (error) {
        console.error('Ошибка удаления новости:', error);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      description: '',
      fullDescription: '',
      image: null,
      published: true
    });
    setEditingNews(null);
    setShowForm(false);
  };

  if (loading) {
    return <div className="admin-loading">Загрузка...</div>;
  }

  return (
    <div className="admin-content">
      <div className="admin-header">
        <h2>Управление новостями</h2>
        <button 
          className="admin-button primary"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? 'Отмена' : 'Добавить новость'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="admin-form">
          <h3>{editingNews ? 'Редактировать новость' : 'Новая новость'}</h3>
          
          <div className="form-group">
            <label>Заголовок</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Краткое описание</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows="3"
              required
            />
          </div>

          <div className="form-group">
            <label>Полное описание</label>
            <textarea
              name="fullDescription"
              value={formData.fullDescription}
              onChange={handleInputChange}
              rows="6"
            />
          </div>

          <ImageUpload
            label="Изображение"
            onImageSelect={handleImageSelect}
            currentImage={editingNews?.image}
          />

          <div className="form-group checkbox">
            <label>
              <input
                type="checkbox"
                name="published"
                checked={formData.published}
                onChange={handleInputChange}
              />
              Опубликовано
            </label>
          </div>

          <div className="form-actions">
            <button type="submit" className="admin-button primary">
              {editingNews ? 'Сохранить' : 'Создать'}
            </button>
            <button type="button" className="admin-button secondary" onClick={resetForm}>
              Отмена
            </button>
          </div>
        </form>
      )}

      <div className="admin-list">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Изображение</th>
              <th>Заголовок</th>
              <th>Дата</th>
              <th>Статус</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {news.map(item => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>
                  {item.image && (
                    <img src={item.image} alt={item.title} className="table-image" />
                  )}
                </td>
                <td>{item.title}</td>
                <td>{new Date(item.date).toLocaleDateString()}</td>
                <td>
                  <span className={`status-badge ${item.published ? 'active' : 'inactive'}`}>
                    {item.published ? 'Опубликовано' : 'Черновик'}
                  </span>
                </td>
                <td>
                  <button 
                    className="admin-button small edit"
                    onClick={() => handleEdit(item)}
                  >
                    Редактировать
                  </button>
                  <button 
                    className="admin-button small delete"
                    onClick={() => handleDelete(item.id)}
                  >
                    Удалить
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NewsManagement;